export default __webpack_public_path__ + "src/images/system_preface/0-343e25.png";